export const API_BASE_URL = "https://api.ashutoshagrawal.dev/sequence";
